import React from "react";
import "./Industries.css";

import Brand1 from "../../Gallery/plogo.png";
import Brand2 from "../../Gallery/royal_warrant.svg";
import Brand3 from "../../Gallery/sunflag-logo.png";
import Brand4 from "../../Gallery/Deslauriers_Logo.webp";
import Brand5 from "../../Gallery/plogo.png";
import Brand6 from "../../Gallery/sunflag-logo.png";
import Brand7 from "../../Gallery/itw.jpeg";



function IndustriesFloatingClean() {
  const logos = [Brand1, Brand2, Brand3, Brand4, Brand5, Brand6, Brand7];

  return (
    <section className="clean_industry_section">
      <h2 className="clean_heading">
        Industries <span>We Serve</span>
      </h2>

      <p className="clean_sub">
        Supplying precision engineering spares and manufacturing support to global industries.
      </p>

      <div className="clean_marquee">
        <div className="clean_track">
          {logos.concat(logos).map((logo, index) => (
            <img 
              key={index}
              src={logo}
              alt={`logo-${index}`}
              className="clean_logo"
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default IndustriesFloatingClean;
